// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5863 ? "f6e815a6" : chunkId) + "." + {"2078":"5921722f65e22b00","2553":"ffe2cc401d098e07","3859":"b1831f7801973307","5863":"1d96925b05a8fdde","8277":"671cdd1e23135f61"}[chunkId] + ".js";
};